//
//
//
import axios from 'axios';

export default async function myAxios(value) {
  //
  if (!value) {
    return false
  }
  //
  let jwt = JSON.parse(sessionStorage.getItem('jwt'))
  let _headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
  if (jwt) {
    _headers.authorization = jwt
  }
  // console.log(_headers);
  value.headers = _headers;
  //
  try {
    const res = await axios(value)
    if (res && res.data) {
      // console.log(res.data);
      if (res.data.status === 403) {
        sessionStorage.removeItem('auth')
        sessionStorage.removeItem('jwt')
        window.location.href = "/login";
      }
      // else
      let r = {
        status: 200,
        data: res.data
      }
      return r;
    }
  } catch (err) {
    // // console.log(err.response.status);
    // // if (err.response.status !== 500){
    //   sessionStorage.removeItem('auth')
    //   sessionStorage.removeItem('jwt')
    //   window.location.href = "/login";
    //   return;
    // // }
  }
}
